export const Statut = {
  SaisieAdherent: 'SaisieAdherent',
  EnCoursDeTransmission: 'EnCoursDeTransmission',
  Archive: 'Archive',
  SaisiePrestataire: 'SaisiePrestataire',
  AReprendreAdherent: 'AReprendreAdherent',
  RefusAdherent: 'RefusAdherent',
  RepriseAdherent: 'RepriseAdherent',
} as const

export type Statut = keyof typeof Statut

export const StatutLibelle: { [key in Statut]: string } = {
  SaisieAdherent: 'En cours de saisie adhérent',
  EnCoursDeTransmission: 'En cours de transmission',
  Archive: 'Archivé',
  SaisiePrestataire: 'En cours de saisie prestataire',
  AReprendreAdherent: "A reprendre par l'adhérent",
  RefusAdherent: "Refusé par l'adhérent",
  RepriseAdherent: "Reprise de la pré-saisie par l'adhérent",
}

export const StatutBadgeType: { [key in Statut]: string } = {
  SaisieAdherent: 'info',
  EnCoursDeTransmission: 'success',
  Archive: 'pending',
  SaisiePrestataire: 'info',
  AReprendreAdherent: "default",
  RefusAdherent: 'error',
  RepriseAdherent: "info",
}

